<script>
import { mapActions } from 'vuex';
import { iModal, openModal } from '@inscribe/signal';

export default {
  components: {
    iModal,
  },
  props: {
    blockToBeDeleted: {
      type: Object,
      default: null,
    },
  },
  watch: {
    blockToBeDeleted(value) {
      if (value) {
        openModal('delete-block-modal');
      }
    },
  },

  methods: {
    ...mapActions(['tryDeleteBlocklist']),
    onClose() {
      this.$emit('on-close');
    },
    onSubmit() {
      const blockId = this.blockToBeDeleted.id;
      this.tryDeleteBlocklist(this.blockToBeDeleted)
        .then(() => {
          this.$store.commit('deleteGeneric', {
            objectsName: 'blocklist',
            idToDelete: blockId,
          });
          this.showMessage({
            title: 'Success',
            text: 'Blocklist updated',
          });
          this.$emit('on-delete');
        })
        .catch((error) => {
          if (error.response !== undefined && error.response.status === 403) {
            this.showMessage({
              title: 'Permission Denied',
              text: 'You do not have permission to delete this blocklist. Please contact your admin if you require this permission.',
              isError: true,
            });
          } else {
            this.showMessage({
              title: 'Error',
              text: error?.data?.message,
              isError: true,
            });
          }
        });
    },
    showMessage(options = {}) {
      this.$notify({
        group: 'api',
        type: options.isError ? 'error' : 'success',
        title: options.title,
        duration: options.duration || 5000,
        text: options.text || '',
      });
    },
  },
};
</script>

<template>
  <div class="wrapper">
    <i-modal
      modal-id="delete-block-modal"
      data-testid="delete-block-modal"
      title="Delete Customer Details"
      confirm-button-text="Delete"
      type="error"
      @on-submit="onSubmit"
      @on-close="onClose"
    >
      <div slot="body-content">
        Are you sure you want to delete this customer's details from the
        blocklist?
      </div>
    </i-modal>
  </div>
</template>
